/**
 * Serialização dos filtros da consolidação de carteira em query params.
 *
 * Regra única, compartilhada pelo caminho por cliente
 * (`serialize-wallet-analysis-params`) e pelo caminho por grupo familiar
 * (`serialize-group-wallet-params`). Cada caminho mantém a SUA guarda de
 * identificação — só o laço de serialização é comum.
 *
 * - `undefined`, `null` e `''` são descartados;
 * - arrays viram JSON (o backend faz `json.loads` de cada filtro) e arrays
 *   vazios são descartados;
 * - `data_requested` é sempre JSON, quando presente e não vazio.
 *
 * @param {Object} filters Filtros já com os nomes de parâmetro da API.
 * @returns {Object} Params prontos para `formatQueryParams`.
 */
export const serializeWalletFilters = ({ data_requested, ...filters } = {}) => {
  const params = {}

  for (const [key, value] of Object.entries(filters)) {
    if (value === undefined || value === null || value === '') continue
    if (Array.isArray(value)) {
      if (value.length > 0) params[key] = JSON.stringify(value)
      continue
    }
    params[key] = value
  }

  if (Array.isArray(data_requested) && data_requested.length > 0) {
    params.data_requested = JSON.stringify(data_requested)
  }

  return params
}
